export default {
  path: 'admin',
  meta: {
    requiresAuth: true,
    requiresRoAccess: true
  },
  component: () => import('./AdminTab')
}
